import React, { useState, useEffect } from "react";
import { Col, Row, Image, DropdownButton, Dropdown } from "react-bootstrap";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import CertificatePic from "./CertificatePic";
import FrontIdPic from "./FrontIdPic";
import BackIdPic from "./BackIdPic";
import Backend from "react-dnd-html5-backend";
import warning from "../../assets/icons/warning.png";
import DraggableComponent from "./../../components/DraggableComponent";
import { DndProvider } from "react-dnd";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export const Seven = (props) => {
  const validate = () => {
    if (window.confirm("Are you sure you want to go back?")) {
      // eslint-disable-line
      props.previousStep();
    }
  };

  const [state, updateState] = useState({
    typeOfDocument: 0,
    authorizeToRunBgCheck: false,
    frontOfCardUrl: "",
    backOfCardUrl: "",
    dBSCertUrl: "",
    backgroundCheck: "",
    countryRegion: "United Kingdom",
    country: ["Pakistan", "United Kingdom", "USA", "Canada", "Srilanka"],
    imageErrorMessage: "",
    certificateError: false,
    showAlert: false,
  });
  useEffect(() => {
    let {
      typeOfDocument,
      authorizeToRunBgCheck,
      frontOfCardUrl,
      backOfCardUrl,
      dBSCertUrl,
      countryRegion,
    } = state;
    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    typeOfDocument = TutorInfoObj?.step7?.typeOfDocument;
    authorizeToRunBgCheck = TutorInfoObj?.step7?.authorizeToRunBgCheck;
    frontOfCardUrl = TutorInfoObj?.step7?.frontOfCardUrl;
    backOfCardUrl = TutorInfoObj?.step7?.backOfCardUrl;
    dBSCertUrl = TutorInfoObj?.step7?.dBSCertUrl;
    countryRegion = TutorInfoObj?.step7?.countryRegion;
    updateState((state) => ({
      ...state,
      typeOfDocument,
      authorizeToRunBgCheck,
      frontOfCardUrl,
      backOfCardUrl,
      dBSCertUrl,
    }));
    if (props.funcStatus === "loading..." && props.currentStep === 7) {
      submitStep7Info(true);
    }
  }, [props]);

  const submitStep7Info = (isCallApi) => {
    const {
      typeOfDocument,
      authorizeToRunBgCheck,
      frontOfCardUrl,
      backOfCardUrl,
      dBSCertUrl,
      countryRegion,
    } = state;

    // step7: {
    //   typeOfDocument: 0,
    //   authorizeToRunBgCheck: true,
    //   frontOfCardUrl: "",
    //   backOfCardUrl: "",
    //   dBSCertUrl: "",
    // },

    const { TutorInfoObj } = props;

    let step7 = {
      typeOfDocument,
      authorizeToRunBgCheck,
      frontOfCardUrl,
      backOfCardUrl,
      dBSCertUrl,
      countryRegion,
    };
    TutorInfoObj.step7 = step7;
    props.AddTutorInfo(TutorInfoObj);
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
    // if (
    //   (typeOfDocument === 0 || typeOfDocument) &&
    //   authorizeToRunBgCheck  &&
    //   frontOfCardUrl &&
    //   backOfCardUrl &&
    //   dBSCertUrl &&
    //   countryRegion
    // ) {
    //   TutorInfoObj.step7 = step7;
    //   props.AddTutorInfo(TutorInfoObj);
    //   return true;
    // } else {
    //   return false;
    // }
  };

  const showAlert = () => {
    confirmAlert({
      title: "Type ",
      title: "Please select a PDF",
      buttons: [
        {
          label: "Ok",
          onClick: () =>
            updateState({
              certificateError: false,
              ...state,
            }),
        },
      ],
      closeOnEscape: true,
    });
  };
  const {
    country,
    countryRegion,
    dBSCertUrl,
    frontOfCardUrl,
    backOfCardUrl,
    typeOfDocument,
    imageErrorMessage,
    certificateError,
    backgroundCheck,
  } = state;
  const { iscompletedForm, validationError } = props;

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <Row className="m-0">
      <WizardSteps step={7} {...props} previousStep={validate} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="subject-mode background"
            >
              <p className="step-title">Add your official ID</p>
              <p className="step-subtitle">
                This helps us check that you are really you. Identity
                verification is one of the ways to keep Askademia secure.
              </p>

              <p className="label">Issuing country/region</p>
              <div className="row">
                <div className="col-12 country">
                  <DropdownButton
                    id="dropdown-basic-button"
                    title={
                      <span>
                        {countryRegion ? countryRegion : "Select Country"}
                        <Image
                          style={{ width: "15px" }}
                          src={require("./../../assets/icons/down-arrow.png")}
                        />
                      </span>
                    }
                  >
                    {!iscompletedForm ? (
                      country && country.length ? (
                        country.map((countryRegion, index) => {
                          return (
                            <Dropdown.Item
                              key={index}
                              className="dropdown-items"
                              onClick={() =>
                                updateState({
                                  ...state,
                                  countryRegion: countryRegion,
                                })
                              }
                              key={index}
                            >
                              {countryRegion}
                            </Dropdown.Item>
                          );
                        })
                      ) : (
                        <Dropdown.Item className="dropdown-items">
                          No Data
                        </Dropdown.Item>
                      )
                    ) : (
                      ""
                    )}
                  </DropdownButton>
                </div>
                <div className="col-4">
                  {/* <span
                    className="green-link"
                    style={{ fontSize: "30px", fontWeight: "400" }}
                  >
                    Change
                  </span> */}
                </div>
              </div>
              <p className="label">Type of document</p>
              <div className="row">
                <div className="col-lg-12 green-radio-custom">
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="customRadioInline73"
                      name="customRadioInline73"
                      className="custom-control-input"
                      defaultChecked={typeOfDocument === 6 ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline73"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              updateState({
                                ...state,
                                typeOfDocument: 6,
                                imageErrorMessage: "",
                              })
                          : () => {}
                      }
                    >
                      Driver’s licence
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="customRadioInline74"
                      name="customRadioInline73"
                      className="custom-control-input"
                      defaultChecked={typeOfDocument === 4 ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline74"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              updateState({
                                ...state,
                                typeOfDocument: 4,
                                imageErrorMessage: "",
                              })
                          : () => {}
                      }
                    >
                      Passport
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="customRadioInline75"
                      name="customRadioInline73"
                      className="custom-control-input"
                      defaultChecked={typeOfDocument === 1 ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline75"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              updateState({
                                ...state,
                                typeOfDocument: 1,
                                imageErrorMessage: "",
                              })
                          : () => {}
                      }
                    >
                      Identity card
                    </label>
                  </div>
                </div>
              </div>
              <p className="step-title">Upload images of your ID</p>
              <p className="step-sub step1">
                Upload images of the front and back of your ID. Make sure your
                images are not cropped, covered or blurred and the front clearly
                shows your face.
              </p>
              <div className="error" style={{ marginBottom: "5px" }}>
                {!typeOfDocument
                  ? imageErrorMessage
                    ? warningError
                    : validationError?.data
                    ? warningError
                    : ""
                  : ""}
                {!typeOfDocument
                  ? imageErrorMessage
                    ? imageErrorMessage
                    : validationError?.data
                    ? "Please select type of document before uploading"
                    : ""
                  : ""}
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                  <DndProvider backend={Backend}>
                    <DraggableComponent
                      TargetChildComponent={FrontIdPic}
                      iscompletedForm={iscompletedForm}
                      validationError={validationError}
                      errorMessagehandling={(error) =>
                        updateState({
                          ...state,
                          imageErrorMessage: error,
                        })
                      }
                      updateImageUrl={(e) =>
                        updateState({
                          ...state,
                          frontOfCardUrl: e,
                        })
                      }
                      imageUrl={frontOfCardUrl}
                      typeNo={
                        typeOfDocument
                          ? typeOfDocument === 1
                            ? "1"
                            : typeOfDocument === 6
                            ? "6"
                            : "4"
                          : ""
                      }
                    />
                  </DndProvider>
                  <div
                    className="error"
                    style={{ marginTop: "-7px", marginBottom: "10px" }}
                  >
                    {!frontOfCardUrl
                      ? validationError?.data?.frontOfCardUrl
                        ? warningError
                        : ""
                      : ""}
                    {!frontOfCardUrl
                      ? validationError?.data?.frontOfCardUrl
                        ? "Add a photo of the front of the identity document"
                        : ""
                      : ""}
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                  <DndProvider backend={Backend}>
                    <DraggableComponent
                      TargetChildComponent={BackIdPic}
                      iscompletedForm={iscompletedForm}
                      validationError={validationError}
                      errorMessagehandling={(error) =>
                        updateState({
                          ...state,
                          imageErrorMessage: error,
                        })
                      }
                      updateImageUrl={(e) =>
                        updateState({
                          ...state,
                          backOfCardUrl: e,
                        })
                      }
                      imageUrl={backOfCardUrl}
                      typeNo={
                        typeOfDocument
                          ? typeOfDocument === 1
                            ? "2"
                            : typeOfDocument === 6
                            ? "7"
                            : "5"
                          : ""
                      }
                    />
                  </DndProvider>
                  <div
                    className="error"
                    style={{ marginTop: "-7px", marginBottom: "10px" }}
                  >
                    {!backOfCardUrl
                      ? validationError?.data?.backOfCardUrl
                        ? warningError
                        : ""
                      : ""}
                    {!backOfCardUrl
                      ? validationError?.data?.backOfCardUrl
                        ? "Add a photo of the back of the identity document"
                        : ""
                      : ""}
                  </div>
                </div>
              </div>

              <p className="certficate_small">
                <i className="mdi mdi-lock mr-1"></i>Your ID is used to verify
                your identity and is not shared with other users of Askademia
              </p>

              <p className="step-title small">
                Do you have which to add a valid DBS or PVG Certificate which
                has been issued within the last 2 years?
              </p>
              <p className="step-subtitle step2">
                You do not need a background check to use our platform tutor,
                however you may miss on oppurtunities where students or parents
                require you to have a background check certificate
              </p>

              <div className="row">
                <div className="col-lg-12 green-radio-custom">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline10"
                      name="customRadioInline10"
                      className="custom-control-input"
                      defaultChecked={backgroundCheck === true ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline10"
                      onClick={() =>
                        updateState({
                          ...state,
                          backgroundCheck: true,
                        })
                      }
                    >
                      Yes
                    </label>
                  </div>
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="customRadioInline11"
                      name="customRadioInline10"
                      className="custom-control-input"
                      defaultChecked={backgroundCheck === false ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customRadioInline11"
                      onClick={
                        !iscompletedForm
                          ? () =>
                              updateState({
                                ...state,
                                backgroundCheck: false,
                              })
                          : () => {}
                      }
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>

              {backgroundCheck ? (
                <div>
                  <p className="step-title">
                    Add your background check Certificate
                  </p>
                  <p className="step-subtitle step2">
                    You do not need a background check to use our platform
                    tutor, however you may miss on opportunities where students
                    or parents require you to have a background check
                    certificate. All tutors who upload a copy of their enhanced
                    background check certificate such as the DBS or PVG will be
                    awarded a verification badge on their tutor profile and have
                    access all tutoring jobs within their speciality.
                  </p>
                  <p className="step-title">Your certificate</p>
                  <p className="step-subtitle step3">
                    Upload a colour copy of your enhanced DBS or PVG certificate
                    which has been issued within the last 2 years
                  </p>
                  <DndProvider backend={Backend}>
                    <DraggableComponent
                      TargetChildComponent={CertificatePic}
                      certificateError={certificateError}
                      ImageUploadAction={props.ImageUploadAction}
                      uploadedImage={props.uploadImage}
                      iscompletedForm={iscompletedForm}
                      errorMessagehandling={(error) => {
                        updateState({
                          ...state,
                          certificateError: error,
                        });
                        setTimeout(() => {
                          updateState({
                            ...state,
                            certificateError: false,
                          });
                          showAlert();
                        }, 1000);
                      }}
                      updateImageUrl={(e) =>
                        updateState({
                          ...state,
                          dBSCertUrl: e,
                        })
                      }
                      imageUrl={dBSCertUrl}
                      typeNo={"3"}
                    />
                  </DndProvider>
                  {!dBSCertUrl ? (
                    props?.validationError?.data?.dBSCertUrl ? (
                      <div
                        className="red-alert-message"
                        style={{ textAlign: "center" }}
                      >
                        {props?.validationError?.data?.dBSCertUrl}
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}

                  <p className="certficate_small">
                    <i className="mdi mdi-lock mr-1"></i>Your certificate is
                    used to verify and award you with a badge on your tutor
                    profile and is not shared with other users of Askademia
                  </p>
                  <p className="step-sub">
                    We request updates from the{" "}
                    <span style={{ color: "#2cb46d" }}>DBS update service</span>{" "}
                    periodically to keep your DBS status updated. Other users of
                    Askademia will not see this information.
                  </p>

                  <div className="checkBoxContainer">
                    <label className="container step4" htmlFor="customCheck61">
                      <span className="currently">
                        By checking this box you authorise Askademia running
                        your DBS Check through the DBS Update Service
                      </span>
                      <input
                        type="checkbox"
                        id="customCheck61"
                        defaultChecked={state.authorizeToRunBgCheck}
                        onClick={
                          !iscompletedForm
                            ? () =>
                                updateState({
                                  ...state,
                                  authorizeToRunBgCheck: !state.authorizeToRunBgCheck,
                                })
                            : () => {}
                        }
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Nextsteps step={7} {...props} submitStepInRedux={submitStep7Info} />
        </div>
      </Col>
    </Row>
  );
};
